// badge_image is stored as a bare filename (e.g. "badgeImage-123.jpg") returned
// by POST /general/upload-badge, or occasionally a full path/URL. Build an
// absolute src for display by prepending the uploads base when it isn't a URL.
export const resolveBadgeImage = (value) => {
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  const base = (process.env.REACT_APP_UPLOADS_URL || '').replace(/\/?uploads\/?$/i, '/uploads/');
  return `${base}${String(value).replace(/^\/?uploads\//i, '')}`;
};
